import { render, staticRenderFns } from "./PolicySearch.vue?vue&type=template&id=57483d7a&"
import script from "./PolicySearch.vue?vue&type=script&lang=js&"
export * from "./PolicySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports